import { BpmRoleAssignmentDepartmentFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

export function BpmRoleAssignmentDepartment({
  data,
}: {
  data?: Hidable<BpmRoleAssignmentDepartmentFragment>;
}) {
  return (
    <Value data={data}>
      {(assignment) => (
        <LocalizedName data={assignment.hierarchyElement.name} />
      )}
    </Value>
  );
}
